<template>
    <div id="renderings_wrapper">
        <div id="renderings">
            <section style="overflow-x: hidden!important" class="stipple-bg">
                <b-container fluid class="header d-md-flex flex-column justify-content-center px-0 nav-padding">
                    <b-row>
                        <b-col md="7" class="pr-md-0 offset-md-2">
                            <img src="/img/we-render-your-vision.svg" alt="We Render Your vision" class="w-100 d-block h-auto fade-in-up-element px-3">
                            <p class="gotham-book mb-0 fade-in-up-element bodycopy-text mt-5 px-3">
                                Remember the days when renderings used to be hand drawn? We do. Because we've been making renderings since before Pearl Jam, Foo Fighters, or Nirvana were even artists. Nowadays with computers though, you can create photo-realistic images in no time and at the click of a button. Damn kids and their fancy machines. 
                            </p>
                        </b-col>
                        <b-col md="3" class="d-flex justify-content-end flex-column">
                            <nuxt-img provider="static" format="webp"
                                src="/img/rendering-wireframe.png" 
                                alt="Renderings Wireframe" 
                                class="d-block w-100"
                                width="468"
                                sizes="xs:100vw sm:100vw lg:468px"
                            />
                        </b-col>
                    </b-row>
                </b-container>
            </section>
            <!--  -->

            <section>
                <b-container fluid class="px-0">
                    <video 
                    src="/videos/Renderings-Video.mp4" 
                    autoplay 
                    loop 
                    muted 
                    playsinline class="w-100 d-block"></video>
                </b-container>
            </section>

            <section id="where-we-do-it" class="stipple-bg">
                <div class="pt-70 pb-120">
                    <b-container>
                        <p class="gotham-book">WHERE WE DO IT/</p>
                        <b-row class="mt-5">
                            <b-col md="12" class="pr-5">
                                <p class="gotham-book mb-0 fade-in-up-element h5">
                                    Renderings bridge the gap between the initial sketch and the final product. It's how you bring your vision to life, and perhaps more importantly, it's how you share it with the world around you. Our remarkable rendering team combines artistic ability and high-tech computers to create stunning and incredibly realistic images of exactly what you see in your mind. Together with your personal account executive, they work tirelessly to ensure every detail is accounted for to deliver a striking visual that is both on budget and on time. 
                                </p>
                            </b-col>
                        </b-row>

                        <b-row class="mt-5">
                            <b-col md="12">
                                <img-comparison-slider>
                                    <img slot="first" src="/img/renderings/img-revealer-1.jpg" class="w-100" />
                                    <img slot="second" src="/img/renderings/img-revealer-2.jpg" class="w-100" />
                                    <div class="img-slider-handle" slot="handle"></div>
                                </img-comparison-slider>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
            </section>
            <!--  -->

            <section>
                <b-container fluid class="px-0">
                    <video 
                    src="/videos/Renderings-3000.mp4" 
                    autoplay 
                    loop 
                    muted 
                    playsinline class="w-100 d-block"></video>
                </b-container>
            </section>

            <section class="stipple-bg pb-100">
                <b-container class="pt-5">
                    <!--  -->
                    <b-row class="mt-70">
                        <b-col sm="6" class="d-md-flex flex-column">
                            <div class="fade-in-up-element overflow-hidden ml-md-auto">
                                <nuxt-img provider="static" format="webp"
                                src="/img/ga-renderings-bathroom.jpg" 
                                alt="Bathroom" 
                                class="w-100 d-block pr-md-5 max-w-360 h-auto"
                                width="492"
                                height="620"
                               />
                            </div>
                        </b-col>
                        <b-col sm="6" class="d-md-flex flex-column justify-content-end mt-5">
                            <div class="max-w-400">
                                <nuxt-img 
                                    loading="lazy" 
                                    provider="static" 
                                    format="webp"
                                    src="/img/quotes-left.png" 
                                    alt="Quotations"
                                    class="d-block max-w-40"
                                    width="40"
                                    height="31"
                                    sizes="lg:41px"
                                />
                                <div class="fade-in-up-element">
                                    <p class="h4 mt-1 ">
                                        It's like plugging your brain 
                                        <br>
                                        into a printer.
                                    </p>
                                </div>
                                <div class="">
                                    <nuxt-img 
                                        loading="lazy" 
                                        provider="static" 
                                        format="webp"
                                        src="/img/quotes-right.png" 
                                        alt="Quotations"
                                        class="d-block max-w-40 ml-auto mr-md-5"
                                        width="40"
                                        height="31"
                                        sizes="lg:41px"
                                    />
                                </div>
                            </div>
                            <div class="mt-5 fade-in-up-element">
                                <div class="overflow-hidden h-100">
                                    <nuxt-img provider="static" format="webp"
                                    src="/img/ga-renderings-dining-area.jpg" 
                                    alt="Fireplace" 
                                    class="w-100 d-block plax-img pt-md-4"
                                    width="540"
                                    height="390"/>
                                </div>
                                <nuxt-img provider="static" format="webp"
                                src="/img/guidelines-circular-stamp-pink.png" alt="Guidelines 1063" class="ga-circular-stamp fade-in-up-element"
                                width="280"
                                height="282"/>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </section>

            <!--  -->
            <section class="stipple-bg position-relative pb-120 conclusion pt-80">
                <SliderLarge :largeSlides="largeSlides"/>
                <b-container class="px-0 position-relative mt-120">
                    <b-row>
                        <b-col md="12" class="position-relative">
                            <div class="fade-in-up-element overflow-hidden">
                                <nuxt-img provider="static" format="webp"
                                src="/img/southport-balcony.jpg" 
                                alt="Southport" 
                                class="w-100 d-block"/>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </section>
            <Transition1063 />
            <AppFooter />
        </div>
    </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
export default {
    data() {
        return {
            scrollSmoother_renderings: null,
            textAnimation_renderings: null,
            fadeInUpElement_renderings: null,
            largeSlides: [
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-balcony.jpg",
                    alt: "Balcony"
                },
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-bar.jpg",
                    alt: "Bar"
                },
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-bedroom.jpg",
                    alt: "Bedroom"
                },
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-den.jpg",
                    alt: "Den"
                },
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-dining-area.jpg",
                    alt: "Dining Area"
                },
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-dining-room.jpg",
                    alt: "Dining Room"
                },
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-dining-room-2.jpg",
                    alt: "Dining Room"
                },
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-gym.jpg",
                    alt: "Gym"
                },
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-kitchen.jpg",
                    alt: "Kitchen"
                },
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-kitchen-4.jpg",
                    alt: "Kitchen"
                },
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-kitchen-5.jpg",
                    alt: "Kitchen"
                },
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-millhouse-foyer.jpg",
                    alt: "Millhouse"
                },
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-porch.jpg",
                    alt: "Front Porch"
                },
                {
                    img: "/img/renderings/large-slider/renderings-lg-slider-shower.jpg",
                    alt: "Shower"
                }
            ],
        }
    },
    components: {
        WhatWeDo: () => import('@/components/WhatWeDo'),
        WhereWeDoIt: () => import('@/components/WhereWeDoIt'),
        TextWheel3D: () => import('@/components/TextWheel3D'),
        InteriorDesignTabOne: () => import('@/components/InteriorDesign/InteriorDesignTabOne'),
        Transition1063: () => import('@/components/Transition1063'),
        SliderLarge: () => import('@/components/InteriorDesign/SliderLarge'),
        AppFooter: () => import('@/components/AppFooter'),
    },
    mounted() {
        gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);
        ScrollTrigger.refresh();
        setTimeout(() => {
            // CALL THIS FIRST SINCE ITS TECHNICALLY A SCROLLTRIGGER, SO ANY SCROLLTRIGGERS FOLLOWING THIS WOULD BE BUILT OFF OF THE SCROLLSMOOTHER
            this.initscrollSmoother_renderings();
            // 
            this.initImgElReveal_renderings();
        }, 500);
    },
    methods: {
        initscrollSmoother_renderings() {
            this.scrollSmoother_renderings = ScrollSmoother.create({
                wrapper: '#renderings_wrapper',
                content: "#renderings",
                smooth: 3,
                effects: true
            });
            this.scrollSmoother_renderings.effects(".plax-img", { speed: "auto" });
        },
        initImgElReveal_renderings() {
            let fadeInUpEl = document.querySelectorAll(".fade-in-up-element");

            fadeInUpEl.forEach((container) => {
                let fadeInUpElement_renderings = this.fadeInUpElement_renderings;
                fadeInUpElement_renderings = gsap.timeline({
                    scrollTrigger: {
                        trigger: container,
                        start: "center bottom",
                        stagger: 0.2
                    }
                });

                fadeInUpElement_renderings.set(container, { autoAlpha: 1 });
                fadeInUpElement_renderings.from(container, 1, {
                    opacity: 0,
                    y: 100,
                    ease: "power2.out"
                });
            });
        },
    },
    beforeDestroy() {
        setTimeout(() => {
            this.scrollSmoother_renderings.kill();
            console.log('ScrollTrigger killed in ' + this.$route.name)
        }, 500)
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/variables';

#renderings_wrapper {
    z-index: 1;
}

#renderings {
    .header {
        height: 100vh;
        min-height: 800px;

        @media screen and (max-width: 1199px) {
            height: auto;
            padding-bottom: 40px;
        }
    }

    .midbanner-text {
        position: absolute;
        bottom: 60px;
        right: 10vw;
    }

    .video-text-overlay {
        position: absolute;
        top: 30px;
        right: 30px;
    }

    .ga-circular-stamp {
        position: absolute;
        left: -204px;
        top: unset;
        bottom: -100px;
        width: 100%;
        max-width: 280px;
        z-index: 1;
    }

    .ga-circular-stamp-2 {
        position: absolute;
        /* left: 0; */
        /* top: 0; */
        bottom: -150px;
        right: -80px;
        width: 100%;
        max-width: 280px;
        z-index: 1;
    }

    img-comparison-slider {
        --divider-width: 1px;
        --divider-color: #000;
        --default-handle-color: #000;
        --handle-position-start: 50%;
        --default-handle-opacity: 1;
        outline: 0; 

        .img-slider-handle {
            background: #000;
            width: 14px;
            height: 14px;
            border-radius: 50%;
        }
    }

    .video-text-overlay {
        position: absolute;
        left: -40px;
        top: 40px;
    }
}


</style>